gsap.registerPlugin(ScrollTrigger);




export function isSvgFile(src) {
	// Check if the source URL ends with .svg
	return src.toLowerCase().endsWith(".svg");
}

export function convertImgToSvg(imgElement) {
	// Get the src attribute of the img element
	const imgSrc =
		imgElement.getAttribute("src") || imgElement.getAttribute("data-src");

	if (!isSvgFile(imgSrc)) {
		// Alert
		console.error("Not an SVG file:", imgSrc);

		const notSvgImg = document.createElement("img");
		notSvgImg.className = "img-generate";
		notSvgImg.style.opacity = 1;
		notSvgImg.src = imgSrc;
		// Replace the original image element with the new one
		imgElement.parentNode.replaceChild(notSvgImg, imgElement);
		return;
	}

	function setStrokeDashArrayInline(svgContent) {
		// Create a new DOM element to parse the SVG content
		const tempDiv = document.createElement("div");
		tempDiv.innerHTML = svgContent;

		// Find all vector path elements in the SVG
		const vectorPaths = tempDiv.querySelectorAll("path");

		// Iterate through vector paths and calculate the stroke-dasharray
		vectorPaths.forEach((path) => {
			const isContainStrokeDasharray =
				path.getAttribute("stroke-dasharray");
			const pathLength = path.getTotalLength();
			path.style.setProperty("--data-stroke-dasharray", pathLength);
			if (isContainStrokeDasharray) return;
			path.setAttribute("stroke-dasharray", pathLength);
		});

		// Return the modified SVG content
		return tempDiv.innerHTML;
	}

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				// Fetching Image SVG
				fetch(imgSrc)
					.then((response) => response.text())
					.then((svgContent) => {
						const modifiedSvgContent =
							setStrokeDashArrayInline(svgContent);
						// Create a temporary div element to parse the SVG content
						const tempDiv = document.createElement("div");
						const isError = svgContent.includes(
							"<title>Error</title>"
						);
						tempDiv.className = "svg-generate";
						if (isError)
							tempDiv.innerHTML =
								"<span class='image-not-found'>Image has been removed or moved.</span>";
						else tempDiv.innerHTML = modifiedSvgContent;
						tempDiv.setAttribute("data-src", imgSrc);
						// Replace the img element with the new svg element
						imgElement.parentNode.replaceChild(tempDiv, imgElement);

						const svgLoadedEvent = new CustomEvent("generate-svg", {
							detail: {
								element: tempDiv,
								source: imgSrc,
								content: modifiedSvgContent,
								isError: isError,
								imgElement,
							},
						});
						document.body.dispatchEvent(svgLoadedEvent);

						// Stop observing the element after it's loaded
						observer.unobserve(imgElement);
					})
					.catch((error) => {
						console.error(
							"Error fetching or replacing image:",
							error
						);
					});
			}
		});
	});
	// Start observing the image element
	observer.observe(imgElement);
}

export function basicTask() {
	const counterItem = document.querySelectorAll(".counter");
	const setBackground = document.querySelectorAll("[setBackground]");
	const menuToggle = document.querySelector(".site-menu-toggle");
	const closeMenu = document.querySelector(".close-menu");
	const searchToggle = document.querySelector(".search-toggle");
	const bodyWrap = document.querySelector("body");
	const menuMobile = document.querySelector(".mobile-nav-wrap");
	const searchWrap = document.querySelector(".searchbox");
	const hamburger = document.querySelector(".hamburger");
	const closeSearch = document.querySelector(".close-search");
	const cardHover = $('.card-option');


	try {
		$(".filter-toggle").on("click", function () {
			$(".mobile-filter-wrap").addClass("is-open");
			$("body").addClass("overlay-bg");
		});
		$(".close-filter").on("click", function () {
			$(".mobile-filter-wrap").removeClass("is-open");
		});
	} catch (error) {

	}
	$("section").each(function () {
		const $section = $(this);
		const $items = $section.find(".tab-item");

		$items.hide(); // hide all first
		const $active = $items.filter(".active");

		if ($active.length) {
			$active.show(); // show only active one
		} else {
			// fallback: show first tab if none marked active
			$items.first().show().addClass("active");
			$section
				.find(".tab-nav li:first")
				.addClass("active")
				.siblings()
				.removeClass("active");
		}
	});
	$(".tab-nav a").on("click", function (e) {
		e.preventDefault();

		const $nav = $(this).parents(".tab-nav");
		const $section = $(this).parents("section");

		// Update active nav link
		$nav.find("li").removeClass("active");
		$(this).parents("li").addClass("active");

		const tab = $(this).attr("data-type");
		const $items = $section.find(".tab-item");

		// Hide all tabs
		$items.hide().removeClass("active");

		// Fade in selected tab
		$section.find("#" + tab).fadeIn(300).addClass("active");
	});


	try {

		$(".toggle-box").each(function (index, element) {
			let $this = $(this);
			$this.addClass("toggle-inst-" + index);
			$(".toggle-inst-" + index + " .title-nav").click(function () {
				if ($(this).parent().hasClass("is-toggle")) {

					$(this).parent().find(".box-content").slideUp();
					$(this).parent().removeClass("is-toggle");
				} else {

					$(this).parent().find(".box-content").slideDown();
					$(this).parent().addClass("is-toggle");
				}
			});
		});
		$(".filter-box").each(function (index) {
			let $box = $(this);
			let $items = $box.find(".facetwp-checkbox");
			let $btn = $box.find(".btn-load-more");

			// Show only first 5
			$items.hide().slice(0, 5).show();

			// Hide button if not enough items
			if ($items.length <= 5) {
				$btn.hide();
			}

			// Toggle
			$btn.on("click", function () {
				if ($box.hasClass("is-toggle")) {
					// Collapse back to 5
					$items.slice(5).slideUp();
					$box.removeClass("is-toggle");
					$(this).find('.text-show').show();
					$(this).find('.text-hide').hide();
				} else {
					// Show all
					$items.slice(5).slideDown();
					$box.addClass("is-toggle");
					$(this).find('.text-show').hide();
					$(this).find('.text-hide').show();
				}
			});
		});

		if (cardHover !== null) {


			cardHover.on('mouseenter', function () {
				$('.card-option').removeClass('is-active');
				$(this).toggleClass('is-active');
			});
		}



	} catch (error) {

	}

	try {
		const flowerContainer = document.querySelector('.develope-petal .container-flower');

		if (flowerContainer) {
			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const droplets = flowerContainer.querySelectorAll('.droplet-wrap');

						// 1. Trigger the animations
						droplets.forEach(droplet => {
							droplet.classList.add('is-visible');
						});

						console.log('Animation started...');

						// 2. Calculate the exact wait time
						// (Number of droplets - 1) * delay (100ms) + duration (3000ms) + buffer (200ms)
						const totalWaitTime = ((droplets.length - 1) * 100) + 3000 + 200;

						setTimeout(() => {
							flowerContainer.classList.add('is-interactive');
							console.log(`Interaction enabled after ${totalWaitTime}ms`);
						}, totalWaitTime);

						observer.unobserve(entry.target);
					}
				});
			}, { threshold: 0.3 });

			observer.observe(flowerContainer);
		}



	} catch (error) {
		console.error(error);
	}













	$(".close-filter").on("click", function () {
		$(".mobile-filter-wrap").removeClass("is-open");
	});

	$(".tab-select select").on("change", function () {
		var tab = $(this).val();
		var section = $(this).parents("section");
		// Target elements with both the ID and the specific class
		section.find(".tab-select-item").removeClass("is-active");
		section.find(".tab-select-item#" + tab).addClass("is-active");
	});
	$("body").on("mouseenter", ".dealer-network .item", function (e) {
		let map = $(this).attr("data-map");
		$(".dealer-network .item").removeClass("is-active");
		$(this).addClass("is-active");
		$(".map-wrap iframe").attr("src", map);
	});


	$(".close-mega").on("click", function () {
		const $megaMenu = $(".mega-menu");

		$megaMenu.addClass("is-closing");

		setTimeout(() => {
			$megaMenu.removeClass("is-closing");
		}, 1000);
	});

	//Toggle Nav
	$(".drop-menu .title em").on("click", function () {
		if ($(this).parents(".drop-menu").hasClass("active")) {
			$(".drop-menu .nav-menu").slideUp();
			$(".drop-menu").removeClass("active");
		} else {
			$(".drop-menu .nav-menu").slideUp();
			$(".drop-menu").removeClass("active");
			$(this).parent().next().slideDown();
			$(this).parents(".drop-menu").addClass("active");
		}
	});
	$(".side-nav-mobile .title-nav").on("click", function () {
		$(".side-nav").slideToggle();
		$(this).parent().toggleClass('is-active');
	});





	try {


		$(".tab-toggle-nav-hover").each(function () {
			const $nav = $(this);
			const $container = $nav.closest("section");
			const $tabWrap = $container.find(".block-tab-wrap");
			const $navLinks = $nav.find(".toggle-item-hover");
			const $tabItems = $container.find(".tab-item-hover");

			let isAnimating = false;
			let pendingTab = null;

			// Init: Set initial state
			$tabItems.hide().css({ opacity: 0, position: "absolute" });
			const $initialTab = $tabItems.filter(".is-active");

			if ($initialTab.length) {
				$initialTab.show().css({ opacity: 1, position: "relative" });
				$tabWrap.css("height", $initialTab.outerHeight());
			}

			function showTab($link) {
				if ($link.hasClass("is-active")) return;

				// If animating, just store the latest request and return
				if (isAnimating) {
					pendingTab = $link;
					return;
				}

				const targetID = $link.attr("data-type");
				const $targetTab = $container.find("#" + targetID);
				const $currentTab = $tabItems.filter(".is-active");

				if (!$targetTab.length) return;

				isAnimating = true;
				pendingTab = null;

				// 1. Setup Navigation
				$navLinks.removeClass("is-active");
				$link.addClass("is-active");

				// 2. Measure target height without showing it
				$targetTab.css({ display: "block", visibility: "hidden", position: "absolute" });
				const endHeight = $targetTab.outerHeight();
				$targetTab.css({ display: "none", visibility: "visible" });

				// 3. Lock wrapper height
				const startHeight = $tabWrap.outerHeight();
				$tabWrap.css("height", startHeight);

				// 4. Outgoing: fade out and hide — THEN show incoming
				$currentTab.stop(true, false).animate({ opacity: 0 }, {
					duration: 300,
					complete: function () {
						$(this).hide().removeClass("is-active").css("position", "absolute");

						// 5. Show incoming AFTER outgoing is fully hidden
						$targetTab.css({ display: "block", opacity: 0, position: "absolute" });

						$tabWrap.stop(true, false).animate({ height: endHeight }, 400, "swing");

						$targetTab.animate({ opacity: 1 }, {
							duration: 400,
							complete: function () {
								$(this).addClass("is-active").css("position", "relative");
								$tabWrap.css("height", "auto");

								isAnimating = false;

								// 6. If user hovered another tab during animation, run it now
								if (pendingTab) {
									const $next = pendingTab;
									pendingTab = null;
									showTab($next);
								}
							}
						});
					}
				});
			}

			$navLinks.on("mouseenter", function (e) {
				e.preventDefault();
				showTab($(this));
			});
		});




		$("section, .home-product").has(".tab-nav-hover").each(function () {
			const $container = $(this);
			const $contentWrap = $container.find(".tab-content-container");
			const $nav = $container.find(".tab-nav-hover");
			const $navLinks = $nav.find("li");
			const $tabItems = $container.find(".tab-item-hover");
			const isMobileTab = () => window.matchMedia("(max-width: 1024px)").matches;

			// Initialization
			const $initialTab = $tabItems.filter(".is-active");
			if ($initialTab.length) {
				$contentWrap.css("background-color", $initialTab.attr("data-color"));
				if (isMobileTab()) {
					$tabItems.removeClass("is-active");
					$initialTab.addClass("is-active");
				} else {
					$tabItems.hide().css("position", "absolute");
					$initialTab.show().css("position", "relative");
				}
			}

			function showTab($link) {
				// Prevent glitch if hovering the already active tab
				if ($link.hasClass("is-active")) return;

				let targetID;
				if ($nav.hasClass("toggle-wrap-hover")) {
					targetID = $link.attr("data-type");
				} else {
					targetID = $link.children("a").attr("data-type");
				}

				const $targetTab = $container.find("#" + targetID);
				const newColor = $targetTab.attr("data-color");

				// 1. Immediate Class Updates
				$navLinks.removeClass("is-active");
				$link.addClass("is-active");

				// 2. Smooth Background Change
				if (newColor) {
					$contentWrap.css("background-color", newColor);
				}

				if (isMobileTab()) {
					$tabItems.removeClass("is-active");
					$targetTab.addClass("is-active");
					return;
				}

				// 3. The "Anti-Glitch" Animation Logic
				// We stop all previous animations and force hidden items to hide 
				$tabItems.not($targetTab).stop(true, true).fadeOut(300, function () {
					$(this).removeClass("is-active").css("position", "absolute");
				});

				$targetTab.stop(true, true).fadeIn(600, function () {
					// Once faded in, we make it relative so it expands the container height naturally
					$(this).addClass("is-active").css("position", "relative");
				});
			}

			if (isMobileTab()) {
				$navLinks.on("click", function (e) {
					e.preventDefault();
					showTab($(this));
				});
			} else {
				$navLinks.on("mouseenter", function (e) {
					e.preventDefault();
					showTab($(this));
				});
			}
		});
	} catch (error) {

	}

	try {

		$(".drop-mega >.title >a").on("click", function (e) { e.preventDefault(); });
		$(".drop-mega >.title .icon").on("click", function () {
			if ($(this).parents(".drop-mega").hasClass("active")) {
				$(".drop-mega .mega-menu").slideUp();
				$(".drop-mega").removeClass("active");
			} else {
				$(".drop-mega .mega-menu").slideUp();
				$(".drop-mega").removeClass("active");
				$(this).parent().next().slideDown();
				$(this).parents(".drop-mega").addClass("active");
			}
		});

	} catch (error) {

	}


	//Basic Toggle Function
	menuToggle?.addEventListener("click", (e) => {
		e.preventDefault();
		menuMobile?.classList.toggle("is-open");
		hamburger?.classList.toggle("is-active");
		bodyWrap?.classList.toggle("overlay-bg");
	});
	closeMenu?.addEventListener("click", () => {
		menuMobile?.classList.remove("is-open");
		hamburger?.classList.remove("is-active");
		bodyWrap?.classList.remove("overlay-bg");
	});
	// Search 
	if (closeSearch !== null) {
		closeSearch.addEventListener("click", () => {
			searchWrap.classList.remove("is-open");
			bodyWrap.classList.remove("overlay-bg");
		});
	}

	// Search Toggle
	searchToggle?.addEventListener("click", () => {
		searchWrap?.classList.toggle("is-open");
		bodyWrap?.classList.toggle("overlay-bg");
	});

	//back to top

	$(".menu-item > a").wrap("<div class='title'></div>");
	$(".menu-item-has-children >.title").append("<div class='icon'></div>");
	//Tab function

	$(".mobile-menu-nav .menu-item-has-children .title .icon").on("click", function () {
		$(this).parent().next().slideToggle();
		$(this).parent().toggleClass('is-active');
	});
	$(".sidenav-group .close-btn").on("click", function () {
		$(this).parents(".sidenav-group").toggleClass('is-open');
	});


	$(".rolling-text").each(function () {
		const $element = $(this);

		// 1. Prevent double-processing
		if ($element.find(".blocker").length > 0) return;

		// 2. Get ONLY the direct text content
		const innerText = $element.clone().children().remove().end().text().trim();
		if (!innerText) return;

		$element.empty();

		// 3. Initialize the Segmenter (using 'vi' for Vietnamese locale)
		const segmenter = new Intl.Segmenter('vi', { granularity: 'grapheme' });
		const graphemes = [...segmenter.segment(innerText)].map(s => s.segment);

		const createTextContainer = () =>
			$("<div>")
				.addClass("blocker")
				.append(
					graphemes.map((letter) =>
						$("<span>")
							.addClass("letter")
							.text(letter === " " ? "\xa0" : letter)
					)
				);

		// Append the two layers for the rolling effect
		$element.append(createTextContainer(), createTextContainer());
	});


	$(".load-more-wrap").each(function () {
		let $wrap = $(this);
		let $items = $wrap.find(".toggle-item");
		let $btn = $wrap.find(".btn-primary");

		let visibleCount = 8;

		// hide all first
		$items.hide();

		// show initial 8
		$items.slice(0, visibleCount).show();

		// hide button if <= 8
		if ($items.length <= visibleCount) {
			$btn.hide();
		}

		$btn.on("click", function () {
			let currentlyVisible = $wrap.find(".toggle-item:visible").length;

			// show next 8
			$items.slice(currentlyVisible, currentlyVisible + visibleCount).slideDown();

			// if all shown → hide button
			if (currentlyVisible + visibleCount >= $items.length) {
				$btn.fadeOut();
			}
		});
	});
	$(".toggle-wrap").each(function (index, element) {
		let $this = $(this);
		$this.addClass("toggle-instance-" + index);
		$(".toggle-instance-" + index + " .toggle-item").click(function () {
			if ($(this).hasClass("is-toggle")) {

				$this.find(".toggle-item").find(".article").slideUp();
				$this.find(".toggle-item").removeClass("is-toggle");
			} else {
				$this.find(".toggle-item").find(".article").slideUp();
				$this.find(".toggle-item").removeClass("is-toggle");
				$(this).find(".article").slideDown();
				$(this).addClass("is-toggle");
			}
		});
	});




	$(".view-more-wrap").each(function () {
		const $wrapper = $(this);
		const initialShow = parseInt($wrapper.data('initial-show') || 4);
		const incrementBy = parseInt($wrapper.data('increment') || 6);

		let currentVisible = initialShow;
		const totalItems = $wrapper.find(".item").length;

		// Show initial items (but don't show more than what exists)
		$wrapper
			.find(".item")
			.slice(0, Math.min(currentVisible, totalItems))
			.show(function () {
				$(this).css("display", "flex");
			});

		// Hide view more button if total items <= initial show amount
		if (totalItems <= initialShow) {
			$wrapper.addClass("disable-btn");
			return; // Exit early since no "view more" functionality is needed
		}

		// Attach click handler to this specific instance
		$wrapper
			.find(".btn-primary")
			.on("click", function (e) {
				e.preventDefault();

				currentVisible += incrementBy;

				$wrapper
					.find(".item")
					.slice(0, currentVisible)
					.slideDown(function () {
						$(this).css("display", "flex");
					});

				// Hide button if all items are now visible
				if (currentVisible >= totalItems) {
					$wrapper.addClass("disable-btn");
				}
			});
	});


	//setBackground
	setBackground.forEach((attributes) => {
		attributes.style.cssText = `
		background-image: url(${attributes.getAttribute("setBackground")});
		background-size: cover;
		background-position: center;
	  `;
	});
	try {
		document.querySelectorAll('.wrap-form textarea').forEach(function (textarea) {
			textarea.value = textarea.value.trim();
		});
	} catch (error) {

	}





	if (counterItem !== null && counterItem.length) {
		const counterUp = window.counterUp.default;

		const callback = (entries) => {
			entries.forEach((entry) => {
				const el = entry.target;

				if (entry.isIntersecting && !el.classList.contains("is-visible")) {
					el.classList.add("is-visible");

					// 1. Wait .35s while showing the "0" version
					setTimeout(() => {
						// 2. Restore the full HTML (including tags like <sub>)
						const fullHTML = el.getAttribute('data-target');
						el.innerHTML = fullHTML;

						// 3. Trigger the counter
						// counterUp is smart enough to find the number inside the tags
						counterUp(el, {
							duration: 3000,
							delay: 40,
						});
					}, 350);
				}
			});
		};

		const IO = new IntersectionObserver(callback, { threshold: 1 });

		counterItem.forEach((counter) => {
			// Save the ENTIRE HTML structure (e.g., 20<sub>m</sub><sup>2</sup>)
			const originalHTML = counter.innerHTML;
			counter.setAttribute('data-target', originalHTML);

			// Replace only the digits with 0, but keep the tags
			// This regex looks for the first number it finds and turns it to 0
			counter.innerHTML = originalHTML.replace(/(\d+)/, '0');

			IO.observe(counter);
		});
	}
	const homeNav = document.querySelector(".home-nav");

	if (homeNav) {
		let ticking = false;

		const getOffset = () => {
			const rect = homeNav.getBoundingClientRect();
			return rect.top + window.scrollY + rect.height;
		};

		let OFFSET = getOffset();

		// Recalculate on resize (important for responsive layouts)
		window.addEventListener("resize", () => {
			OFFSET = getOffset();
		});

		window.addEventListener("scroll", () => {
			if (!ticking) {
				requestAnimationFrame(() => {
					document.body.classList.toggle(
						"is-active-nav",
						window.scrollY > OFFSET
					);
					ticking = false;
				});
				ticking = true;
			}
		});
	}


}
